document.addEventListener("DOMContentLoaded", () => {

  // Get Started modal: open/close
  const modal = document.getElementById("get-started-modal");

  if (modal) {
    const openModal = () => {
      modal.classList.add("is-open");
      document.body.classList.add("modal-is-open");
    };

    const closeModal = () => {
      modal.classList.remove("is-open");
      document.body.classList.remove("modal-is-open");
    };

    document.querySelectorAll("[data-open-modal='get-started']").forEach((trigger) => {
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        openModal();
      });
    });

    modal.querySelectorAll("[data-modal-close]").forEach((el) =>
      el.addEventListener("click", closeModal)
    );
  }

  // Get Started form: Salesforce Web-to-Lead submit + shadow Mailchimp submit
  const gameStudioForm = document.querySelector("#game-studio-form");

  if (gameStudioForm) {
    (function (form) {
      const
        submitButton = form.querySelector("#get-started-submit-button"),
        firstName = form.querySelector("#first_name"),
        lastName = form.querySelector("#last_name"),
        emailInput = form.querySelector("#email"),
        companyInput = form.querySelector("#company"),
        utmInput = form.querySelector(".utm_source"),
        mailChimpEmailInput = document.querySelector("#mce-EMAIL"),
        mailChimpFullNameInput = document.querySelector("#mce-FNAME"),
        mailChimpCompanyInput = document.querySelector("#mce-COMPANY"),
        mailChimpSubmitButton = document.querySelector("#mc-embedded-subscribe"),
        emailValidation = emailInput.parentElement,
        mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
        pageUrl = window.location.href,
        formActionUrl = "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D5e000001Oxvi";

      utmInput.value = pageUrl.split("?")[1];

      [emailInput, firstName, lastName, companyInput].forEach((el) =>
        el.addEventListener("keyup", el === emailInput ? emailCheck : emptyCheck)
      );

      form.addEventListener("submit", (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const emailValue = emailInput.value;

        if (
          emailValue.match(mailFormat) != null &&
          emailValue &&
          firstName.value &&
          lastName.value &&
          companyInput.value
        ) {
          form.action = formActionUrl;
          submitButton.classList.add("loading");

          if (mailChimpEmailInput && mailChimpFullNameInput && mailChimpCompanyInput && mailChimpSubmitButton) {
            mailChimpEmailInput.value = emailInput.value;
            mailChimpFullNameInput.value = `${firstName.value} ${lastName.value}`;
            mailChimpCompanyInput.value = companyInput.value;
            mailChimpSubmitButton.click();
          }

          window.dataLayer?.push({
            event: "form_submitted",
            full_name: `${firstName.value} ${lastName.value}`,
            email: emailInput.value,
            company_name: companyInput.value
          });

          setTimeout(() => {
            form.submit();
          }, 2000);

        } else {
          checkFields();
          emailCheck();
        }
      });

      function emailCheck() {
        const emailInputValue = emailInput.value;

        if (emailInputValue.match(mailFormat)) {
          emailValidation.classList.remove("error");
        } else {
          emailValidation.classList.add("error");
        }
      }

      function emptyCheck() {
        const inputElm = this;

        if (inputElm instanceof HTMLInputElement) {
          inputElm.parentElement.classList.toggle("error", !inputElm.value);
        } else if (inputElm instanceof HTMLSelectElement) {
          const isSelectEmpty = inputElm.multiple
            ? inputElm.selectedOptions.length === 0
            : inputElm.value === "";
          inputElm.parentElement.classList.toggle("error", isSelectEmpty);
        }
      }

      function checkFields() {
        const inputs = form.querySelectorAll("[required]");

        inputs.forEach((input) => {
          if (input instanceof HTMLInputElement) {
            input.parentElement.classList.toggle("error", !input.value);
          } else if (input instanceof HTMLSelectElement) {
            const isSelectEmpty = input.multiple
              ? input.selectedOptions.length === 0
              : input.value === "";
            input.parentElement.classList.toggle("error", isSelectEmpty);
          }
        });
      }
    })(gameStudioForm);
  }

  // Newsletter form (Beyond Vanilla): Mailchimp JSONP submit
  const newsletterForm = document.querySelector("#newsletter-form");

  if (newsletterForm) {
    (function (form) {
      const
        successMessage = document.querySelector("#newsletter-success-message"),
        errorMessage = form.querySelector("#newsletter-error-message"),
        submitButton = form.querySelector("#newsletter-submit-button"),
        fullNameInput = form.querySelector("#newsletter-full-name"),
        jobTitleInput = form.querySelector("#newsletter-job-title"),
        emailInput = form.querySelector("#newsletter-email"),
        companyInput = form.querySelector("#newsletter-company"),
        mailChimpForm = document.querySelector("#mc-embedded-subscribe-form-newsletter"),
        mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/,
        mailChimpUserId = "5542885c5f38ae9a4108ab154",
        mailChimpAudienceId = "fcab8181b2",
        mailChimpFormId = "0062aae1f0";

      let submitTimeout;
      let isSubmitting = false;

      const fields = [fullNameInput, jobTitleInput, emailInput, companyInput];

      fields.forEach((field) => {
        field.addEventListener("input", () => validateField(field));
      });

      form.addEventListener("submit", (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (isSubmitting) return;

        const isValid = fields.map((field) => validateField(field)).every(Boolean);

        if (!isValid) return;

        submitButton.classList.add("loading");
        errorMessage.classList.remove("active");
        submitFormData();
      });

      function validateField(field) {
        const value = field.value.trim();
        const isEmail = field === emailInput;
        const isValid = isEmail ? mailFormat.test(value) : Boolean(value);

        field.parentElement.classList.toggle("error", !isValid);

        return isValid;
      }

      function splitFullName(fullName) {
        const parts = fullName.trim().split(/\s+/);
        const firstName = parts.shift() || "";
        const lastName = parts.join(" ");

        return { firstName, lastName };
      }

      function submitFormData() {
        const mcFirstName = document.querySelector("#newsletter-mce-FNAME");
        const mcLastName = document.querySelector("#newsletter-mce-LNAME");
        const mcEmail = document.querySelector("#newsletter-mce-EMAIL");
        const mcCompany = document.querySelector("#newsletter-mce-COMPANY");
        const mcJobTitle = document.querySelector("#newsletter-mce-JOBTITLE");
        const { firstName, lastName } = splitFullName(fullNameInput.value);

        if (!mailChimpForm || !mcFirstName || !mcLastName || !mcEmail || !mcCompany || !mcJobTitle) {
          showStatusMessage("Something went wrong", "Please try again.");
          return;
        }

        mcFirstName.value = firstName;
        mcLastName.value = lastName;
        mcEmail.value = emailInput.value.trim();
        mcCompany.value = companyInput.value.trim();
        mcJobTitle.value = jobTitleInput.value.trim();

        isSubmitting = true;
        submitMailchimpJsonp();
      }

      function submitMailchimpJsonp() {
        const callbackName = `newsletterMailchimpCallback_${Date.now()}`;
        const mailChimpUrl = new URL(mailChimpForm.action);
        const mailChimpParams = new URLSearchParams(mailChimpUrl.search);
        const script = document.createElement("script");

        mailChimpUrl.pathname = mailChimpUrl.pathname.replace("/post", "/post-json");
        mailChimpParams.set("u", mailChimpUserId);
        mailChimpParams.set("id", mailChimpAudienceId);
        mailChimpParams.set("f_id", mailChimpFormId);

        new FormData(mailChimpForm).forEach((value, key) => {
          mailChimpParams.set(key, value);
        });

        mailChimpParams.set("c", callbackName);
        mailChimpParams.set("_", Date.now());
        mailChimpUrl.search = mailChimpParams.toString();

        window[callbackName] = (response) => {
          cleanup();

          if (response?.result === "success") {
            showStatusMessage(
              "Sign up successful",
              "Thank you for subscribing to the CurseForge for Studios newsletter."
            );
            return;
          }

          showStatusMessage("Something went wrong", "Please try again.");
        };

        script.onerror = () => {
          cleanup();
          showStatusMessage("Something went wrong", "Please try again.");
        };

        clearTimeout(submitTimeout);
        submitTimeout = setTimeout(() => {
          cleanup();
          showStatusMessage("Something went wrong", "Please try again.");
        }, 15000);

        script.src = mailChimpUrl.toString();
        document.body.appendChild(script);

        function cleanup() {
          clearTimeout(submitTimeout);
          delete window[callbackName];
          script.remove();
        }
      }

      function showStatusMessage(title, description) {
        const statusTitle = successMessage?.querySelector("#newsletter-status-title");
        const statusDescription = successMessage?.querySelector("#newsletter-status-description");

        isSubmitting = false;
        submitButton.classList.remove("loading");

        if (statusTitle) statusTitle.textContent = title;
        if (statusDescription) statusDescription.textContent = description;

        successMessage?.classList.add("active");
        form.closest(".newsletter-form-wrap")?.classList.add("submitted");
      }
    })(newsletterForm);
  }

});
